import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { HistorianStorageConfiguration } from '../../models/entities';
import { HistorianStorageQueryResultDto, LogbookHistorianStorageQueryResult, LogbookHistorianStorageResult } from '../../models/DTO';

export interface IHistorianStorageConfigurationService {
    getAll(): angular.IPromise<HistorianStorageConfiguration[]>;
    save(configurations: HistorianStorageConfiguration[]): angular.IPromise<HistorianStorageConfiguration[]>;
    delete(guids: string[]): angular.IPromise<HistorianStorageConfiguration[]>;
    execute(configuration: HistorianStorageConfiguration): angular.IPromise<HistorianStorageQueryResultDto[]>;
    executeByLogbook(configuration: HistorianStorageConfiguration, beginDateTime: string, endDateTime: string): angular.IPromise<LogbookHistorianStorageQueryResult[]>;
    store(configuration: HistorianStorageConfiguration, beginDateTime: string, endDateTime: string): angular.IPromise<LogbookHistorianStorageResult>;
}

export class HistorianStorageConfigurationService implements IHistorianStorageConfigurationService {
    static serviceId = 'historianStorageService';

    private _controllerUrl = 'historianStorage/';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<HistorianStorageConfiguration[]> {
        return this._requestService.getAtV1(this._controllerUrl);
    }

    save(configurations: HistorianStorageConfiguration[]): angular.IPromise<HistorianStorageConfiguration[]> {
        return this._requestService
            .postAtV1<HistorianStorageConfiguration[]>(this._controllerUrl, configurations)
            .then(data => {
                this.cleanCache();
                return data;
            });
    }

    delete(guids: string[]): angular.IPromise<HistorianStorageConfiguration[]> {
        return this._requestService.postAtV1<HistorianStorageConfiguration[]>(`${this._controllerUrl}delete`, guids)
            .then(data => {
                this.cleanCache();
                return data;
            });
    }

    execute(configuration: HistorianStorageConfiguration): angular.IPromise<HistorianStorageQueryResultDto[]> {
        return this._requestService.postAtV1(`${this._controllerUrl}execute`, configuration);
    }

    executeByLogbook(configuration: HistorianStorageConfiguration, beginDateTime: string, endDateTime: string): angular.IPromise<LogbookHistorianStorageQueryResult[]> {
        return this._requestService.postAtV1(`${this._controllerUrl}executeByLogbook`, configuration, { beginDateTime, endDateTime });
    }

    store(configuration: HistorianStorageConfiguration, beginDateTime: string, endDateTime: string): angular.IPromise<LogbookHistorianStorageResult> {
        return this._requestService.postAtV1(`${this._controllerUrl}store`, configuration, { beginDateTime, endDateTime });
    }

    cleanCache() {
        this._requestService.cleanCacheAtV1(this._controllerUrl);
        this._requestService.cleanCacheAtV1('identifierQuery');
    }
}